'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import t from "../defs/CaretDown.es.js";
const e = a.forwardRef((r, t$1) => /* @__PURE__ */ a.createElement(p, { ref: t$1, ...r, weights: t }));
e.displayName = "CaretDownIcon";
const s = e;
export {
  s as CaretDown,
  e as CaretDownIcon
};
